/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TreatmentSelect/Content/Content/Content/Option"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let selectedIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: '_id',
})
let treatmentIdValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: '_id',
})
let aggregateData = fromAggregate.equals(selectedIdValueData, treatmentIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  closePopover,
  viewPath,
  isHovered
  
})
let treatmentTxCardNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'tx_card.name',
})
  return (<React.Fragment
>
<button
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--btlr-1-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-2-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-6-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-7-Z2h7tiu': isHovered ? dtColorsNeutral200 : aggregateData ? dtColorsNeutral200 : "transparent"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="treatment.tx_card.name"
 text={treatmentTxCardNameValueData}
/>
</button>
{children}
</React.Fragment>)
}